import { AddressContextProvider } from "./AddressContext";
import { EntitiesContextProvider } from "./EntitiesContext";
import { FileUploadContextProvider } from "./FileUploadContext";
import { OrderContextProvider } from "./OrderContext";
import { PaymentContextProvider } from "./PaymentContext";
import { AdminContextProvider } from "./AdminContext";
import { LoginContextProvider } from "./LoginAdminContext";

const Contexts = ({ children }: any) => (

  <LoginContextProvider>
    <EntitiesContextProvider>
        <AddressContextProvider>
          <FileUploadContextProvider>
            <OrderContextProvider>
              <PaymentContextProvider>
                <AdminContextProvider>{children}</AdminContextProvider>
              </PaymentContextProvider>
            </OrderContextProvider>
          </FileUploadContextProvider>
        </AddressContextProvider>
    </EntitiesContextProvider>
  </LoginContextProvider>

);

export default Contexts;
